import React from 'react';

import { IPopover, Popover } from '@xcritical/popover';

import { ReduxInject } from '@crm-framework/saga-injector';

import { LeadShortInfo } from '../LeadShortInfo';
import { leadShortInfoReducer, STORE_NAME } from '../store';
import { watchShortLeadInfo } from '../sagas';

import { ActiveElement } from './styled';

interface ILeadShortInfoPopover extends Omit<IPopover, 'content'> {
  leadId: number;
}

export const LeadShortInfoPopover: React.FC<ILeadShortInfoPopover> = ({
  leadId,
  children,
  ...popoverProps
}) => (
  <Popover {...popoverProps} content={<LeadShortInfo leadId={leadId} />}>
    <ActiveElement>{children}</ActiveElement>
  </Popover>
);

export const LeadShortInfoPopoverWithInject: React.FC<
  ILeadShortInfoPopover
> = ({ children, ...props }) => (
  <ReduxInject
    keyName={STORE_NAME}
    reducer={leadShortInfoReducer}
    saga={watchShortLeadInfo}>
    <LeadShortInfoPopover {...props}>{children}</LeadShortInfoPopover>
  </ReduxInject>
);
